import { __awaiter } from "tslib";
import React from 'react';
import { createRoot } from 'react-dom/client';
import { createTheme, ThemeProvider as MuiThemeProvider, StyledEngineProvider, } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Provider as ReduxProvider } from 'react-redux';
import * as Sentry from '@sentry/react';
import { ThemeProvider } from 'styled-components';
import { theme as componentsTheme } from '@groupby/ui-components';
import { deepmerge } from '@mui/utils';
import TagManager from 'react-gtm-module';
import { LicenseInfo } from '@mui/x-license';
import createStore from './store';
import { ccThemeOptions } from './theme';
import { FeatureFlagsProvider, featureFlagsService, initializeFeatureFlagsService } from '@/search-for-retail/feature-flags';
import { App } from '@/app/app';
import { setStore } from '@/store/store-proxy';
import { COOKIE_CONSENT_KEY, GTM_CONTAINER_ID, isConsentValid, ls, } from '@/stores/local-storage';
const metaVersion = document.querySelector('meta[name="version"]');
const release = metaVersion instanceof HTMLMetaElement ? metaVersion.content : undefined;
Sentry.init({
    dsn: 'https://407cff966cecce719a8c771c39517250@o4506151900872704.ingest.sentry.io/4506151914897408',
    release,
    environment: window.location.hostname,
});
const storedConsent = ls.getItem(COOKIE_CONSENT_KEY);
const hasConsent = storedConsent != null && isConsentValid(storedConsent) && storedConsent.value === 'accepted';
const store = createStore();
setStore(store);
void (() => __awaiter(void 0, void 0, void 0, function* () {
    yield initializeFeatureFlagsService();
    // Initialize Google Tag Manager only when user has given consent
    if (hasConsent) {
        TagManager.initialize({ gtmId: GTM_CONTAINER_ID });
    }
    // Initialize MUI License Info
    LicenseInfo.setLicenseKey('baeb22c2cd2fccd8ac65e69b94471de8Tz0xMzI5MDQsRT0xODIwNzA3MTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1RMy0yMDI0LEtWPTI=');
    const theme = createTheme(deepmerge(componentsTheme, ccThemeOptions));
    const container = document.getElementById('app');
    const root = createRoot(container);
    root.render(
    // Strict Mode will be enabled in separate ticket
    // <React.StrictMode>
    <FeatureFlagsProvider featureFlagsService={featureFlagsService}>
      <DndProvider backend={HTML5Backend}>
        <StyledEngineProvider injectFirst>
          <MuiThemeProvider theme={theme}>
            <ThemeProvider theme={theme}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <ReduxProvider store={store}>
                  <App />
                </ReduxProvider>
              </LocalizationProvider>
            </ThemeProvider>
          </MuiThemeProvider>
        </StyledEngineProvider>
      </DndProvider>
    </FeatureFlagsProvider>
    // </React.StrictMode>
    );
}))();
